import { render, staticRenderFns } from "./wf-option-list-with-sub-options-display.vue?vue&type=template&id=4670a302&scoped=true&"
import script from "./wf-option-list-with-sub-options-display.vue?vue&type=script&lang=ts&"
export * from "./wf-option-list-with-sub-options-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-option-list-with-sub-options-display.vue?vue&type=style&index=0&id=4670a302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4670a302",
  null
  
)

export default component.exports